// extracted by mini-css-extract-plugin
module.exports = {"root":"_2diSQ","link":"_1CwUH","img":"_3QcwU"};